import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './style.css';

import { PageComponent, Button, Input, Card } from '../../components';
import Api from '../../Api';

export default function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const navigate = useNavigate();

  async function handleSubmit(event) {
    event.preventDefault();
    setError('');

    if (!name || !email || !password || !confirmPassword) {
      setError('Preencha todos os campos.');
      return;
    }

    if (password !== confirmPassword) {
      setError('As senhas não conferem.');
      return;
    }

    setLoading(true);

    try {
      const data = await Api.register(name, email, password);

      if (data && data.token) {
        localStorage.setItem('authToken', data.token);

        if (data.user) {
          localStorage.setItem('authUser', JSON.stringify(data.user));
        }

        navigate('/');
      } else {
        setError(
          data && data.error
            ? data.error
            : 'Não foi possível realizar o cadastro.'
        );
      }
    } catch (err) {
      setError('Erro ao cadastrar. Tente novamente.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <PageComponent authenticatedPage={false}>
      <div className="register-page">
        <div className="register-panel">
          <div className="register-brand">
            <img src="logo_black.png" alt="Maxximus Tecnologia" className="register-logo" />
            <h1 className="register-title">Crie sua conta Maxximus</h1>
            <p className="register-description">
              Cadastre-se para começar a organizar suas empresas, postos e equipes.
            </p>
          </div>
          <Card className="register-card">
            <h2 className="register-card-title">Cadastro de acesso</h2>
            <p className="register-card-subtitle">
              Informe seus dados básicos para criar o primeiro usuário do sistema.
            </p>
            <form className="register-form" onSubmit={handleSubmit}>
              <Input
                id="name"
                type="text"
                label="Nome completo"
                placeholder="Seu nome"
                value={name}
                onChange={event => setName(event.target.value)}
              />
              <Input
                id="email"
                type="email"
                label="E-mail"
                placeholder="voce@email.com"
                value={email}
                onChange={event => setEmail(event.target.value)}
              />
              <Input
                id="password"
                type="password"
                label="Senha"
                placeholder="Crie uma senha"
                value={password}
                onChange={event => setPassword(event.target.value)}
              />
              <Input
                id="confirm-password"
                type="password"
                label="Confirme a senha"
                placeholder="Repita a senha"
                value={confirmPassword}
                onChange={event => setConfirmPassword(event.target.value)}
              />
              {error && <div className="register-error">{error}</div>}
              <div className="register-actions">
                <Button type="submit" fullWidth className="register-submit" disabled={loading}>
                  {loading ? 'Cadastrando...' : 'Criar conta'}
                </Button>
              </div>
              <div className="register-secondary-actions">
                <span className="register-link-text">
                  Já tem conta?
                  {' '}
                  <Link to="/login" className="register-link-button">
                    Fazer login
                  </Link>
                </span>
              </div>
            </form>
          </Card>
        </div>
      </div>
    </PageComponent>
  );
}

